"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overview = exports.Save = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Save = function (_a) {
    var channel = _a.channel, setChannel = _a.setChannel, submit = _a.submit;
    return react_1.default.createElement(storybook_1.Ecaptures.FormOptions, { submit: submit, options: channel.options, setOptions: function (key, value) {
            var _a;
            setChannel({ options: __assign(__assign({}, channel.options), (_a = {}, _a[key] = value, _a)) });
        } });
};
exports.Save = Save;
var Overview = function (_a) {
    var channel = _a.channel;
    return react_1.default.createElement(storybook_1.Ecaptures.List, { channel: channel });
};
exports.Overview = Overview;
